const WhitelabelDomain = () => import('./WhitelabelDomain.vue')
const WhitelabelColors = () => import('./WhitelabelColors.vue')
const WhitelabelImages = () => import('./WhitelabelImages.vue')

export default [
  {
    name: 'whitelabel-domain',
    path: 'whitelabel-domain',
    component: WhitelabelDomain,
    meta: {
      superAdminOnly: true
    }
  },
  {
    name: 'whitelabel-colors',
    path: 'whitelabel-colors',
    component: WhitelabelColors,
    meta: {
      superAdminOnly: true
    }
  },
  {
    name: 'whitelabel-images',
    path: 'whitelabel-images',
    component: WhitelabelImages,
    meta: {
      superAdminOnly: true
    }
  }
]
